import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { JoiResource, ResourceContact } from 'globals/store/resources.data';
import { FontCSS, JoiTemplate, getJoiTemplate } from 'globals/store/publish.data';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { MutatingInputComponent } from 'src/app/components/joi-input/mutating-input.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'manage-resource-contact',
    templateUrl: './manage-resource-contact.html',
    styleUrls: ['./manage-resource-contact.scss'],
    styles: [`
  `],
    standalone: true,
    imports: [DialogWrapperComponent, CommonModule, ImageUploaderComponent, ToggleTabComponent, MutatingInputComponent],
})
export class ManageResourceContactComponent {
  contact: ResourceContact
  resource: JoiResource
  maxHeight: 'unset'
  template: JoiTemplate = getJoiTemplate()
  FontCSS = FontCSS
  imageUploaderDisplayTypes = imageUploaderDisplayTypes

  constructor(public dialogRef: MatDialogRef<ManageResourceContactComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageResourceContactData, private dialog: MatDialog) {
    const { contact, resource, template } = data
    console.log(data)
    this.contact = jsonCopyObject(contact)
    this.resource = jsonCopyObject(resource)
    if (template) this.template = template
  }

  close() {
    this.data.contact = this.contact
    this.data.resource = this.resource
    this.dialogRef.close(this.data)
  }

  changeUrls(result) {
    this.contact.photoURL = result ? result.photoUrl : null
  }

  togglePrimaryContact() { // not sure how this is supposed to work if always must have a primary contact
    const isContact = this.resource.primaryContactId === this.contact.id
    if (isContact) this.resource.primaryContactId = null
    else this.resource.primaryContactId = this.contact.id
  }

  async delete(event) {
    const data = {
      title: "Delete contact",
      para: "This action cannot be undone",
      dialog: this.dialog,
      rect: event.target.getBoundingClientRect(),
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.dialogRef.close({ delete: true })
  }

}


export interface ManageResourceContactData {
  contact: ResourceContact
  resource: JoiResource
  public: boolean
  fromTemplate: boolean
  eventId: string
  publishCode: string
  template: JoiTemplate
}